import { periodLabel, recentPeriods } from '../lib/useAccounts';

/**
 * THE MONTH AS ONE CONTROL, ON A PHONE — the boards print "Aug 2026 ▾" and
 * open a list, rather than lay the recent months out as three chips.
 */
export function MonthPick({ period, onChange }: { period: string; onChange: (next: string) => void }) {
  const all = recentPeriods();
  const months = all.includes(period) ? all : [period, ...all];
  return (
    <label className="chip chip-brand chip-sm" style={{ position: 'relative', cursor: 'pointer' }}>
      {periodLabel(period)} ▾
      <select
        aria-label="Month"
        value={period}
        onChange={(e) => onChange(e.target.value)}
        style={{ position: 'absolute', inset: 0, width: '100%', opacity: 0, cursor: 'pointer' }}
      >
        {months.map((p) => (
          <option key={p} value={p}>{periodLabel(p)}</option>
        ))}
      </select>
    </label>
  );
}
